import { render, staticRenderFns } from "./OrdemDeServicoLiberarItensView.vue?vue&type=template&id=7f0f39e5&scoped=true"
import script from "./OrdemDeServicoLiberarItensView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemDeServicoLiberarItensView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdemDeServicoLiberarItensView.vue?vue&type=style&index=0&id=7f0f39e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f39e5",
  null
  
)

export default component.exports